import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetExplicitPermissionsParams {
  permissions: IAuthorizableGranteePermissions[];
}

export interface ISetExplicitPermissionsResult extends IResult {
}

export class SetExplicitPermissionsRequest extends Request<ISetExplicitPermissionsParams, ISetExplicitPermissionsResult> {
  constructor(params: ISetExplicitPermissionsParams) {
    super('setExplicitPermissions', params);
  }
}
